import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n-context";
import { BOOTH_TYPES } from "@/lib/booth-data";
import { Button } from "@/components/ui/button";
import { Check, ArrowRight } from "lucide-react";

export default function BoothInfoPage() {
  const { t } = useLang();
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
      <div className="mb-12 max-w-3xl">
        <div className="text-xs uppercase tracking-widest text-brand-red font-semibold mb-3">Booth Rental</div>
        <h1 className="font-display text-4xl md:text-5xl font-bold">{t("booths_title")}</h1>
        <p className="text-muted-foreground mt-4 text-lg">
          Choose the tent/booth type that suits your business. All prices include tax and standard equipment
          (2 tables + 4 chairs) unless otherwise noted.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {BOOTH_TYPES.map((b, i) => (
          <div
            key={b.key}
            className="bg-white rounded-3xl border border-border overflow-hidden hover:-translate-y-1 transition-transform"
            data-testid={`booth-type-${b.key}`}
          >
            <div
              className="aspect-[4/3] bg-cover bg-center"
              style={{ backgroundImage: `url(${b.image})` }}
            />
            <div className="p-6">
              <div className="text-xs uppercase tracking-widest text-brand-red font-semibold mb-2">
                Type 0{i + 1}
              </div>
              <h3 className="font-display text-2xl font-bold">{b.name}</h3>
              <div className="text-sm text-muted-foreground mt-1">{b.nameJa}</div>
              <div className="mt-4 flex items-baseline gap-2">
                <div className="font-display text-3xl font-bold text-brand-red">
                  ¥ {b.priceJpy}
                </div>
                <div className="text-xs text-muted-foreground">/ event (tax incl.)</div>
              </div>
              <div className="text-xs text-muted-foreground mt-1">Size: {b.size}</div>
              <ul className="mt-5 space-y-1.5 text-sm">
                {b.equipment.map((e, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <Check className="w-4 h-4 text-brand-red mt-0.5 flex-shrink-0" />
                    <span>{e}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-16 bg-brand-canvas rounded-3xl p-8 md:p-12 grid md:grid-cols-3 gap-8 items-center">
        <div className="md:col-span-2">
          <h3 className="font-display text-2xl md:text-3xl font-bold">
            Ready to register your booth?
          </h3>
          <p className="text-muted-foreground mt-2">
            Restaurant / Catering, Traders, Craft/Fashion or Local Government — sign in and fill out the private registration form.
          </p>
        </div>
        <Button asChild size="lg" className="rounded-full h-12 bg-brand-red hover:bg-brand-red-dark text-white" data-testid="booths-cta-register">
          <Link to="/register">Register a booth <ArrowRight className="w-4 h-4 ml-2" /></Link>
        </Button>
      </div>
    </div>
  );
}
